module.exports = __webpack_public_path__ + "static/img/preview_builder.edaf216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v7/preview_builder.jpg
// module id = 8pwf
// module chunks = 0